(function () {
  function initScentFinder(root) {
    var finder = root.querySelector('[data-pr-scent-finder]');
    if (!finder) return;

    var buttons = finder.querySelectorAll('[data-pr-mood]');
    var results = finder.querySelectorAll('[data-pr-result]');

    function showMood(mood) {
      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', button.getAttribute('data-pr-mood') === mood ? 'true' : 'false');
      });
      results.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-pr-result') === mood);
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        showMood(button.getAttribute('data-pr-mood'));
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initScentFinder(document); });
  document.addEventListener('shopify:section:load', function (event) { initScentFinder(event.target); });
}());
